import { connectCustom } from "@client/lib/misc";
import { type WithChildren } from "@client/types/WithChildren";
import Component, { type LayoutPlaceProps } from "./component";

export type LayoutPlaceContainerProps = WithChildren & {
  className?: string;
  style?: React.CSSProperties;
};
const mapStateToProps = (state: {}, props: LayoutPlaceContainerProps): LayoutPlaceProps => {
  return {
    ...props
  };
};

export default connectCustom(mapStateToProps)(Component);
